import { useMemo } from 'react'
import { SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import { mergeNoteThreadsIntoNavThreads } from '@/features/chat/noteThreadNavMerge'

/** @param {ReturnType<typeof import('./useChatPersistedSlices').useChatPersistedSlices>} state */
export function useDisplayThreadState(state) {
  const {
    activePrimaryKey,
    homeView,
    urlThreadId,
    selectedThreadId,
    threads,
    pinnedThreadIds,
  } = state

  const navThreads = useMemo(() => mergeNoteThreadsIntoNavThreads(threads), [threads])

  const displayThreadId = useMemo(() => {
    if (activePrimaryKey !== 'home') return null
    if (homeView === SECONDARY_VIEW_KEYS.HOME_BOARDS_ALL) return selectedThreadId
    if (urlThreadId) {
      if (navThreads.some((t) => t.id === urlThreadId)) return urlThreadId
      return null
    }
    return selectedThreadId
  }, [activePrimaryKey, homeView, urlThreadId, navThreads, selectedThreadId])

  const pinnedThreadIdsForNav = useMemo(
    () => pinnedThreadIds.filter((id) => navThreads.some((t) => t.id === id)),
    [pinnedThreadIds, navThreads],
  )

  return { navThreads, displayThreadId, pinnedThreadIdsForNav }
}
